import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import FloatingAlert from "../../../components/FloatingAlert/FloatingAlert";
import bgSliders from "../../../helpers/bgSliders";
import "./SignupPage.styled";
import GamezoneOnlineSignupPageDisplay from "./SignupPage.styled";
import { setLoginData } from "../../../helpers/helpers";
import { Trans, withTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { setAgencyData, saveTracker } from "../../../helpers/agencyTracker";
import queryString from "query-string";



const randomBg = bgSliders.getRandomBg();
function GamezoneOnlinePin({ t, i18n }) {
   const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("i18nextLng", lng);
    
    // Optional: Update URL without reload
    const newUrl = `${window.location.pathname}?lang=${lng}`;
    window.history.pushState({}, '', newUrl);
  };

  const [activeData, setActiveData] = useState("");
  const [checkPhone, setCheckPhone] = useState(false);
  const [phone, setPhone] = useState("");
  const [showverif, setShowverif] = useState(false);
  const [verifyCode, setVerifyCode] = useState("");
  const [errorMesg, setErrorMesg] = useState(false);
  const [subMesg, setSubMesg] = useState(false);

  const [verfiErrorMesg, setVerfiErrorMesg] = useState(false);
  const [showPin, setShowPin] = useState(true);
  const [showUncomplete, setUncomplete] = useState(false);

  const [errorresverify, seterrorresverify] = useState("");

  const [randomString, setRandomString] = useState('');
  const [errorMesgSubscribe, setErrorMesgSubscribe] = useState("");

  const [otpid, setotpid] = useState("");
  const [showLoading, setshowLoading] = useState(false);

  const [fromParam, setFromParam] = useState(false); // track source


  const history = useHistory();
  const [alert, setAlert] = useState(false);

 

useEffect(() => {
    // Handle language from URL or localStorage
    const params = queryString.parse(window.location.search);
    const urlLang = params.lang;
    const storedLang = localStorage.getItem("i18nextLng");
    
    // Priority: URL param > localStorage > default 'ar'
    const langToSet = urlLang || storedLang || 'ar';
    
    if (langToSet !== i18n.language) {
      i18n.changeLanguage(langToSet);
    }
    localStorage.setItem("i18nextLng", langToSet);

    // Your existing phone parameter handling
    const urlParams = new URLSearchParams(window.location.search);
    const phone = urlParams.get('MSISDN');
    if (phone) {
      setActiveData(phone);
      setFromParam(true);
    }

    if (window.location.search !== "") {
      setAgencyData(window.location.search);
    }
  }, []);

  useEffect(() => {
    if (activeData && fromParam) {
      console.log("activeData =>", activeData);
    //  Subscribe(); 
    }
  }, [activeData, fromParam]);

const Subscribe = () => {
  if (activeData) {
    const phon_n = activeData.toString();
    const url = `http://vas2.grand-hub.com/api/PlayIt/ooredoo-om-d/subscribe`;

    setshowLoading(true);

    axios.post(url, { phone: phon_n })
      .then((res) => {
        if (res.data.success === true) {
          localStorage.setItem("phone", phon_n);
          setShowverif(true);
        } else {
          console.log("rana", res.data.message);
          const lang = localStorage.getItem("i18nextLng");
          if (lang === "ar") {
                      setErrorMesg(true);
            setErrorMesgSubscribe("يرجى التحقق من رقم الجوال");

          } else  {
            setErrorMesgSubscribe(res.data.message);

                      setErrorMesg(true);

          }
          //setErrorMesgSubscribe();
         // setErrorMesgSubscribe(res.data.message);
          setShowverif(false);
        }
      })
      .catch((error) => {
        var message = '';
                setErrorMesg(true);
               console.log("rana catch", error.response);

        if(error.response.data.success === false){
          const lang = localStorage.getItem("i18nextLng");
          if (lang === "ar") {
            message = "يرجى التحقق من رقم الجوال";
          }
          else{
          message=  (error.response && error.response.data && error.response.data.message)
                      || "An unexpected error occurred.";
          }

         

        }

        setErrorMesgSubscribe(message);
        setShowverif(false);
      })
      .finally(() => {
        setshowLoading(false);
      });
  }
};




  const verify = async e => {
    e.preventDefault();
    if (verifyCode) {
      var phon_n = activeData;
      setshowLoading(true);
      axios.post(`http://vas2.grand-hub.com/api/PlayIt/ooredoo-om-d/verify` , {
       
          phone: phon_n,
          otp: verifyCode
      
      })
        .then(res => {
          setshowLoading(false);
          if (res.data.status === true) {
              setLoginData(res.data.user_id, res.data.token, res.data.user_name, res.data.photo, res.data.operator_id, res.data.user_email, res.data.msisdn);
            tracker(phon_n);
            gtag_report_conversion();
            setVerfiErrorMesg(false);
            history.push("/complete-gamezoline");
          } else {
         
                        setshowLoading(false);

             setVerfiErrorMesg(true);
             seterrorresverify(res.data.message);
          }
          setshowLoading(false);

        })
        .catch(function (error) {
         //console.log(error);
         
          
           var message = '';
             

        if(error.response.data.success === false){
           setVerfiErrorMesg(true);
          const lang = localStorage.getItem("i18nextLng");
          if (lang === "ar") {
            message = "يرجى التحقق من رمز التفعيل ";
          }
          else{
          message=  (error.response && error.response.data && error.response.data.message)
                      || "An unexpected error occurred.";
          }
                     seterrorresverify(message);

        }
            setshowLoading(false);

        })
        .finally(function () {

         //console.log('complete');
        });
    }
  };


  function gtag_report_conversion() {
    let tracker_value = localStorage.getItem('tracker');
      if(localStorage.getItem(tracker_value) != '1'){
        window.gtag('event', 'conversion', {
          'send_to': 'AW-619421651/C_ScCIHe_qcZENO_rqcC'
      });
      localStorage.setItem(tracker_value,'1')
    }
    return false;
  }


  const tracker = async (GMSISDN) => {
    var datag = {};
    if (localStorage.getItem('tracker')) {
     
      datag = {
        key: 'parameter',
        company: localStorage.getItem("trackerCompany"),
        value: localStorage.getItem('tracker'),
        identifierKey: 'id',
        identifierValue: 'IROXEZv1kd',
        phoneNum: GMSISDN
      };
     //console.log(datag)

    }
    await saveTracker(datag);

  }
return (
  <GamezoneOnlineSignupPageDisplay className="">
    {/* Alerts */}
    {alert && (
      <FloatingAlert type="danger">
        In order to signup please turn your mobile data.
      </FloatingAlert>
    )}

    {errorMesg && (
      <FloatingAlert type="error">
        <Trans>{errorMesgSubscribe}</Trans>
      </FloatingAlert>
    )}

    {subMesg && (
      <FloatingAlert type="success">
        <Trans>{errorMesgSubscribe}</Trans>
      </FloatingAlert>
    )}

    {verfiErrorMesg && (
      <FloatingAlert type="error">
        <Trans>{errorresverify}</Trans>
      </FloatingAlert>
    )}

    <div className="operatorSignup">
      <div className="formsLayout formsLayoutjawal">
        {/* Header */}
        <div className="header header_gamezone">
          <Link to="/">
            <div className="logo gamezoneLogo" />
          </Link>
          <div className="language-switcher">
            <button
              onClick={() => changeLanguage('en')}
              className={i18n.language === 'en' ? 'active' : ''}
            >
              EN
            </button>
            <button
              onClick={() => changeLanguage('ar')}
              className={i18n.language === 'ar' ? 'active' : ''}
            >
              AR
            </button>
          </div>
        </div>

       
        {showPin ? (
          <div className="links-Section links-Sectionjawwalgamezorid">
            <h3 className="gamezoridcontent" id="gamezoridcon">
              <Trans>Your content is ready!</Trans>
            </h3>

            <div className="play" />

            {!showverif ? (
              <>
                <div className="number-inputs">
                  <input readOnly value="+968" className="countryCode" />
                  <input
                    type="text"
                    className="input gamezoneInput"
                    style={{ fontSize: '12px' }}
                    placeholder={t("Enter_your_phone_number")}
                    value={activeData}
                    disabled={checkPhone}
                    onChange={(e) =>
                      setActiveData(e.target.value.replace(/[^0-9]/g, ""))
                    }
                  />
                </div>

                <button
                  className="AFsubmitbtn btn"
                  id="AFsubmitbtn"
                  disabled={!activeData}
                  onClick={Subscribe}
                >
                  {t("Subscribe")}
                </button>
              </>
            ) : 
            (
              <div className="verfiySection">
                <p><Trans>verifycodeJawwalGameszorid</Trans></p>
                <input
                  type="text"
                  className="input"
                  value={verifyCode}
                  placeholder={t("Enter_verifycode")}
                  onChange={(e) =>
                    setVerifyCode(e.target.value.replace(/[^0-9]/g, ""))
                  }
                />
              
                <button
                  className="AFsubmitbtn btn"
                  id="AFsubmitbtn"
                  disabled={!verifyCode}
                  onClick={(e) => verify(e)}
                >
                  {t("Confirm")}
                </button>
              </div>
            )}

            <p className="text-center">{t("By_Subscribing")}</p>
          <div className="container-fluid px-0">
  <div className="row flex-nowrap text-center gx-2 gx-lg-3 justify-content-lg-center overflow-auto">
    {[
      { value: "98%", img: "like.png", label: "evaluation" },
      { value: "1000+", img: "Repeat.png", label: "games" },
      { value: "500k+", img: "group.png", label: "users" },
    ].map(({ value, img, label }, index) => (
      <div key={index} className="col-auto px-2 px-lg-3">
        <div className="games-info jawwalgames-info">
          <span>{value}</span>
          <img
            src={`/assets/images/subscribegamezriod/${img}`}
            alt="icon"
            className="iconsimg"
          />
          <p><Trans>{label}</Trans></p>
        </div>
      </div>
    ))}
  </div>
</div>
          </div>
        ) : (
          <div className="links-Section links-Sectionjawwalgamezorid">
            {/* Initial content when showPin is false */}
          </div>
        )}
       
        <div className="footer ">
          <div className="">
            <ul style={{ listStyleType: 'none' }}>
              <li>{t('welcome_games_online')}</li>
              <li>{t('daily_charge_info')}</li>
              <li>{t('deduct_from_balance')}</li>
              <li>{t('auto_renew_cancel_info')}</li>
              <li>{t('age_or_permission_required')}</li>
              <li>{t('content_language_notice')}</li>
            </ul>
          </div>
        </div>

        {/* Loading Spinner */}
        {showLoading && (
          <div className="load">
            <div className="spinerC">
              <div className="spinner"></div>
            </div>
          </div>
        )}
      </div>
    </div>
  </GamezoneOnlineSignupPageDisplay>
);

}
export default withTranslation()(GamezoneOnlinePin)
